import { createContext } from 'react';

import { InternalCategoricalBarChartThresholdConfiguration } from '../types/categorical-bar-chart.js';

export const CategoricalBarChartThresholdsContext = createContext<
  InternalCategoricalBarChartThresholdConfiguration[]
>([]);

CategoricalBarChartThresholdsContext['displayName'] =
  'CategoricalBarChartThresholdsContext';
